import React from 'react';
import ClientsList from '../components/ClientsList';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ClientEvolutionDetails from '../components/ClientEvolutionDetails';


class Evolution extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			showDetails: false,
			clientId: null
		}
	}

	componentDidMount() {
		if (this.props.match.params.id) {
			this.setState({
				showDetails: true,
				clientId: this.props.match.params.id
			})
		}
	}

	render() {

		return (
			<div className="content">
				{this.state.showDetails === false && this.state.clientId === null ? (
					<ClientsList
						btnTitle={"Visualizza dettaglio"}
						maxCheckboxes={1}
						name={this.props.name}
						user={this.props.user}
						type={"evolution"}
					/>
				) : (
					this.state.clientId >= 0 ? (
						<ClientEvolutionDetails
							clientId={parseInt(this.state.clientId)}
							user={this.props.user} />
					) : (
						console.log("Errore: competitor non valido")
					)
				)}
			</div >
		)
	}
}

Evolution.propTypes = {
	dispatch: PropTypes.func.isRequired,
	isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
	isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps)(Evolution);